import { FormControlLabel, IconButton, Radio, RadioGroup, TextField } from '@mui/material'
import React from 'react'

function Step1() {
    return (
        <>
            <div className="form">
                <div className="gap_p">
                    <div className="control_group">

                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            name="radio-buttons-group"
                            className="checkbox_list"
                        >
                            <FormControlLabel
                                value="female"
                                control={<Radio />}
                                label={
                                    <>
                                        <b> Pause My Store (Temporary Closure)</b>
                                        Store hidden from customers (products not visible).<br />
                                        Orders can still be fulfilled and payouts processed.<br />
                                        Can be reactivated anytime.
                                    </>
                                }
                            />

                            <FormControlLabel value="male" control={<Radio />} label={<>
                                < b >Permanently Close My Store</b>
                                Triggers a formal Store Closure Request workflow with admin approval<br />
                                All data (orders, financials, customers) is archived but retained for compliance.<br />
                                You account cannot create new listings or receive new orders.

                            </>}
                            />
                        </RadioGroup>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Step1